import { render, staticRenderFns } from "./PermissionablesCard.vue?vue&type=template&id=3c93db8c"
import script from "./PermissionablesCard.vue?vue&type=script&lang=js"
export * from "./PermissionablesCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports